import React, { useEffect, useState } from 'react'
import ParametrosApi from 'services/robinhood/ParametrosApi';
import ValoresApi from 'services/robinhood/ValoresApi';

export default function Footer() {
    const [updateTime, setUpdateTime] = useState({ 'UPDATE_TIME': null });
    const parametrosApi = new ParametrosApi();
    const [rodapeExibir, setRodapeExibir] = useState(0);

    useEffect(() => {
        getValues();
    }, []);

    const getValues = async () => {
        await new ParametrosApi().all().then(response => {
            response.map(parametro => {
                if (parametro.id == parametrosApi.rodape_exibir) {
                    setRodapeExibir(parseInt(parametro.valor));
                }
            });
        });

        await new ValoresApi().updateTime().then(response => {
            if (response.UPDATE_TIME) {
                setUpdateTime(response);
            }
        });
    }
    return (
        <>
            {rodapeExibir == 1 && updateTime.UPDATE_TIME &&
                <span className='text-muted' style={{ position: 'absolute', fontSize: '10px', right: '25px', marginTop: '-25px' }}>
                    <i className='zmdi zmdi-calendar' style={{ fontSize: '10px' }}></i>  ÚLTIMA ATUALIZAÇÃO DE DADOS :
                    <span style={{ fontWeight: 'normal', marginLeft: '5px' }}>{new Date(updateTime.UPDATE_TIME).toLocaleString('pt-BR')}</span>
                </span>}
        </>
    )
}